import React, { Fragment } from "react";
import { LayoutWidgetType } from "@irati/types";
import CompanyNews from "../CompanyNews";
import TenantProducts from "../TenantProducts";
var ManageHomePageLayout = function (_a) {
    var companyNews = _a.companyNews, id = _a.id, layoutWidgets = _a.layoutWidgets, pageView = _a.pageView, isAdmin = _a.isAdmin, openModal = _a.openModal;
    return (React.createElement(React.Fragment, null, layoutWidgets.config.map(function (_a, index) {
        var content = _a.content;
        return (React.createElement(Fragment, { key: content.type },
            content.type === LayoutWidgetType.CompanyNews && (React.createElement(CompanyNews, { id: id, pageView: pageView, isAdmin: isAdmin, companyNews: companyNews, openModal: openModal })),
            content.type === LayoutWidgetType.Products && React.createElement(TenantProducts, { id: id, pageView: pageView, alignOverlayToBottom: index > 0 })));
    })));
};
export default ManageHomePageLayout;
